// src/pages/TplinkTapoDeco.jsx
import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

export default function TplinkTapoDeco() {
  return (
    <div className="min-h-screen bg-[#111111] text-white scroll-smooth">
      <Helmet>
        <title>TP-Link Tapo Deco Mesh Wi-Fi | SeguraTech</title>
        <meta
          name="description"
          content="Experience seamless whole-home Wi-Fi with TP-Link’s Deco Mesh systems — fast, reliable connectivity powered by Wi-Fi 6 and Wi-Fi 7."
        />
        <meta property="og:title" content="TP-Link Tapo Deco Mesh Wi-Fi | SeguraTech" />
        <meta
          property="og:description"
          content="TP-Link Deco Mesh Wi-Fi delivers complete home coverage, lightning-fast speeds, and advanced security powered by Wi-Fi 6 and Wi-Fi 7."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.seguratech.co.uk/tplink/tapo-deco"
        />
        <meta property="og:image" content="/tplink-logo.png" />
      </Helmet>

      {/* Hero Section */}
      <section className="max-w-5xl mx-auto px-4 py-20 text-center">
        <h1 className="text-4xl md:text-6xl font-extrabold leading-tight tracking-tight text-[#C6A564] mb-6">
          TP-Link Tapo Deco Mesh Wi-Fi
        </h1>
        <p className="text-lg text-white/80 max-w-3xl mx-auto">
          Whole-home mesh coverage with cutting-edge speed, reliability, and
          security. TP-Link’s Deco systems eliminate dead zones and deliver
          uninterrupted Wi-Fi for every device, everywhere.
        </p>
      </section>

      {/* Mesh Wi-Fi Categories */}
      <section className="max-w-6xl mx-auto px-4 pb-24">
        <div className="grid md:grid-cols-2 gap-10">
          {/* Wi-Fi 6 Systems */}
          <div className="border border-[#C6A564] rounded-2xl p-8 bg-[#1a1a1a] hover:bg-[#222222] transition">
            <h2 className="text-2xl font-semibold text-[#C6A564] mb-4 text-center">
              Wi-Fi 6 Mesh Systems
            </h2>
            <p className="text-white/80 text-center mb-8">
              Designed for high-performance homes, TP-Link’s Wi-Fi 6 Deco range
              ensures faster speeds, higher capacity, and seamless roaming.
            </p>
            <div className="grid sm:grid-cols-2 gap-6">
              <div className="border border-[#C6A564] rounded-xl p-6 bg-[#111111] hover:bg-[#1c1c1c] transition text-center">
                <h3 className="text-lg font-medium text-[#C6A564] mb-2">
                  Deco X20 / X50
                </h3>
                <p className="text-white/80 text-sm">
                  Ideal for small to medium homes — fast dual-band Wi-Fi 6
                  coverage with strong reliability and easy setup.
                </p>
              </div>
              <div className="border border-[#C6A564] rounded-xl p-6 bg-[#111111] hover:bg-[#1c1c1c] transition text-center">
                <h3 className="text-lg font-medium text-[#C6A564] mb-2">
                  Deco X68 / X90
                </h3>
                <p className="text-white/80 text-sm">
                  Tri-band Wi-Fi 6 with powerful performance and AI-driven
                  routing for uninterrupted streaming and gaming.
                </p>
              </div>
            </div>
          </div>

          {/* Wi-Fi 7 Systems */}
          <div className="border border-[#C6A564] rounded-2xl p-8 bg-[#1a1a1a] hover:bg-[#222222] transition">
            <h2 className="text-2xl font-semibold text-[#C6A564] mb-4 text-center">
              Wi-Fi 7 Mesh Systems
            </h2>
            <p className="text-white/80 text-center mb-8">
              Next-generation connectivity — Deco BE series brings multi-gigabit
              speeds, ultra-low latency, and superior stability for demanding
              smart homes.
            </p>
            <div className="grid sm:grid-cols-2 gap-6">
              <div className="border border-[#C6A564] rounded-xl p-6 bg-[#111111] hover:bg-[#1c1c1c] transition text-center">
                <h3 className="text-lg font-medium text-[#C6A564] mb-2">
                  Deco BE65
                </h3>
                <p className="text-white/80 text-sm">
                  Tri-band Wi-Fi 7 system with 10G Ethernet support and
                  industry-leading performance for future-proof networks.
                </p>
              </div>
              <div className="border border-[#C6A564] rounded-xl p-6 bg-[#111111] hover:bg-[#1c1c1c] transition text-center">
                <h3 className="text-lg font-medium text-[#C6A564] mb-2">
                  Deco BE85
                </h3>
                <p className="text-white/80 text-sm">
                  Flagship quad-band Wi-Fi 7 system — unparalleled coverage,
                  stability, and intelligent network optimisation.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Back to Overview */}
      <div className="text-center pb-16">
        <Link
          to="/tplink"
          className="text-[#C6A564] hover:text-[#E7D7B0] transition underline"
        >
          ← Back to TP-Link Overview
        </Link>
      </div>
    </div>
  );
}
